import React, {useContext, useState} from "react";
import OutsideClickHandler from "react-outside-click-handler";
import FilterContext from "../../Context/FilterContext";
import VerticalHit from "../../Hits/VerticalHit";
import {Marker, Popup} from "react-map-gl";

const Announce = props => {
    const { hit, customMarkerColor } = props
    const { color } = hit;
    const [show, setShow] = useState(false)

    const handleOutsideClick = () => {
        setShow(false)
    }

    const handleClick = () => {
        setShow(true)
    }

    return (
        <>
            {
                show ?
                    <Popup
                        longitude={hit._geoloc.lng}
                        latitude={hit._geoloc.lat}
                        closeButton={false}
                        closeOnClick={false}
                        focusAfterOpen={false}
                        maxWidth={'18rem'}
                    >
                        <OutsideClickHandler onOutsideClick={handleOutsideClick}>
                            <VerticalHit hit={hit} props={{ class: 'inline-block w-64' }} />
                        </OutsideClickHandler>
                    </Popup>
                : null
            }

            <Marker longitude={hit._geoloc.lng} latitude={hit._geoloc.lat} onClick={handleClick} color={customMarkerColor ?? color} scale={hit.option_highlighting_active ? 1.25 : .75} style={{cursor: 'help'}}/>
        </>
    )
}

export default Announce